import { isScriptLoaded } from './dom';
import config from '../config';

const gtagSource = config.gtag.scriptSource;
const gtagId = config.gtag.gtagId;

export const injectGtag = () => {
  const headTag = document.querySelector(`head`);
  const scriptAlreadyLoaded = isScriptLoaded(gtagSource);
  const isPrd = config.env === `prod`;
  if(headTag && !scriptAlreadyLoaded && isPrd) {
    const gtagLibScriptElement = document.createElement(`script`);
    gtagLibScriptElement.setAttribute(`async`, ``);
    gtagLibScriptElement.setAttribute(`src`, `${gtagSource}?id=${gtagId}`);
    headTag.prepend(gtagLibScriptElement);
  }
};

export const logPageView = (path) => {
  if (typeof window.gtag !== `function`) {
    return false;
  }

  window.gtag(`config`, gtagId, { 'page_path': path });
  return true;
};



// WEBPACK FOOTER //
// ./client/services/gtag.js